import { showApiError, showSuccess } from "@/lib/toast";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateContentGroupMemberCategory } from "@/sideEffects/api";
import { ContentGroupMemberCategory } from "@/lib/types";
import { ContentGroupMemberCategoryMetaForm, FormSchemaType } from "../form/ContentGroupMemberCategoryMetaForm";
import { useSelector } from "react-redux";
import { selectActiveFirm } from "@/store/appSelectors";

interface Props {
  category: ContentGroupMemberCategory;
}

export const UpdateteContentGroupMemberCategory: React.FC<Props> = ({ category }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  const queryClient = useQueryClient();
  const updateMutation = useMutation({
    mutationFn: (values: FormSchemaType) =>
      updateContentGroupMemberCategory({
        id: category.id,
        name: values.categoryName,
        firmGuid: String(activeFirm?.firmGuid),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getContentGroupMemberCategory"],
      });
      showSuccess(t("common.updatedSuccess"));
    },
    onError: showApiError,
  });

  return (
    <ContentGroupMemberCategoryMetaForm
      buttonText={t("common.update")}
      onSubmit={(values) => updateMutation.mutate(values)}
      isLoading={updateMutation.isPending}
      defaultValues={{ categoryName: category.name }}
    />
  );
};
